import React from 'react';
import { Link } from 'components/Link';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import styled from 'styled-components';
import { colors } from 'styleguide/colors';
import { P2 } from 'styleguide/Texts';
import { ThemeState, themeState } from 'styleguide/theme';
import { Icon, IconType } from 'styleguide/Icons';
import { CornerRadius, Spacing } from 'styleguide/spacing';
import { modal } from 'components/Modals/ModalManager';
import { FlexRow } from 'styleguide/Row';
import { View } from 'styleguide/View';

interface NavBarRouteProps {
  title: string;
  iconType: IconType;
  isSelected: boolean;
  path: string;
}

const Container = styled(View)`
  cursor: pointer;
  width: 100%;
  border-radius: ${CornerRadius.sm}px;
  padding-top: ${Spacing.sm}px;
  padding-bottom: ${Spacing.sm}px;
`;

const Content = styled(FlexRow)`
  flex: 1;
  justify-content: flex-start;
  padding-inline-start: ${Spacing.sm}px;
  gap: ${Spacing.sm}px;
`;

export const NavBarRoute = observer(({ title, isSelected, path, iconType }: NavBarRouteProps) => {
  const [isHovering, setIsHovering] = useState(false);

  const tint = ((themeState: ThemeState) => {
    if (isSelected) return themeState.current.accent;

    return themeState.current.primary;
  })(themeState);

  const backgroundColor = ((themeState: ThemeState) => {
    if (isSelected) {
      return '#8EC2FF1A';
    } else if (isHovering) {
      return themeState.current.name === 'light' ? colors.greyHiperLight : colors.greyUltraDark;
    }
    return undefined;
  })(themeState);

  return (
    <Link href={path} style={{ marginBottom: Spacing.sm }}>
      <Container
        style={{ backgroundColor: backgroundColor }}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        onClick={() => (modal.isMobileNavBarModalOpen = false)}
      >
        <Content>
          <Icon type={iconType} dark={tint} light={tint} />
          <P2 style={{ color: tint }}>{title}</P2>
        </Content>
      </Container>
    </Link>
  );
});
